export const CLONE_OBJ_LENGTH = 2;
// export const is_left_clone = 'is_left_clone';
// export const is_right_clone = 'is_right_clone';
export const clone_parent_cid = 'clone_parent_cid';
